import React, { forwardRef, useImperativeHandle, useState } from "react";
import { cn } from "../../../Utils/helper";

const CommonModal = forwardRef(
  ({ title, children, actions, className, onOverlayAction }, ref) => {
    const [isOpen, setIsOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      openModal: () => setIsOpen(true),
      closeModal: () => setIsOpen(false),
    }));

    if (!isOpen) return null;

    const closeModal = () => {
      setIsOpen(false);
    };

    const handleOverlayClick = (e) => {
      if (e.target === e.currentTarget) {
        if (onOverlayAction) {
          onOverlayAction();
          closeModal();
        } else {
          closeModal();
        }
      }
    };

    const handleModalBodyClick = (e) => {
      e.stopPropagation();
    };

    return (
      <div
        onClick={handleOverlayClick}
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 h-screen w-screen"
      >
        <div
          onClick={handleModalBodyClick}
          className={cn(
            "flex flex-col items-center bg-white rounded-xl p-5 max-w-[380px] w-full text-center max-h-[90vh] overflow-auto",
            className
          )}
        >
          <h2 className="text-lg text-stone-900">{title}</h2>
          <div className="mt-4 w-full">{children}</div>

          {typeof actions === "function" && (
            <div className="flex gap-3.5 justify-center mt-2 w-full text-sm tracking-tight">
              {actions(closeModal)}
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default CommonModal;
